import { useCallback } from 'react'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'
import { Button } from '@mui/material'
import { useSnackbar } from '@ui/snackbar'
import {
  parseConnectionFromClipboardText,
  preparePastedConnection,
} from '../utils/clipboardConnection'

interface Props {
  onPaste: (connection: Connection) => void
}

const PasteConnectionFromClipboardButton = ({ onPaste }: Props) => {
  const { enqueueSnackbar } = useSnackbar()

  const handlePaste = useCallback(async () => {
    try {
      const connectionData = await navigator.clipboard.readText()
      const connection = parseConnectionFromClipboardText(connectionData)

      if (!connectionData.trim()) {
        enqueueSnackbar('Kein Zugverbinder in der Zwischenablage', { variant: 'warning' })
        return
      }

      if (!connection) {
        enqueueSnackbar('Fehler beim Einfügen des Zugverbinders', { variant: 'error' })
        return
      }

      onPaste(preparePastedConnection(connection))
      enqueueSnackbar('Zugverbinder eingefügt', { variant: 'success' })
    } catch {
      enqueueSnackbar('Fehler beim Einfügen des Zugverbinders', { variant: 'error' })
    }
  }, [enqueueSnackbar, onPaste])

  return (
    <Button
      startIcon={<ContentPasteIcon />}
      onClick={handlePaste}
      variant="outlined"
      size="small"
      data-cy="paste-connection-from-clipboard"
    >
      Zugverbinder aus Zwischenablage einfügen
    </Button>
  )
}

export default PasteConnectionFromClipboardButton
